import { Button } from "@/components/ui/button";
import { Crown, LogOut } from "lucide-react";

export function AdminHeader({ adminUser, onLogout }) {
  return (
    <div className="bg-gray-900 text-white px-6 py-4 flex items-center gap-3">
      <Crown className="w-6 h-6 text-amber-400" />
      <div className="flex-1">
        <h1 className="text-lg font-bold">Kaiso System - Admin Master</h1>
        <p className="text-xs text-gray-400">Logado como: {adminUser?.email}</p>
      </div>
      <Button
        variant="ghost"
        size="sm"
        onClick={onLogout}
        className="text-gray-400 hover:text-white hover:bg-gray-800 gap-1.5"
        data-testid="admin-logout-btn"
      >
        <LogOut className="w-4 h-4" /> Sair
      </Button>
    </div>
  );
}
